import { render, staticRenderFns } from "./ShellList.vue?vue&type=template&id=2f4d290e&scoped=true&"
import script from "./ShellList.vue?vue&type=script&lang=js&"
export * from "./ShellList.vue?vue&type=script&lang=js&"
import style0 from "./ShellList.vue?vue&type=style&index=0&id=2f4d290e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4d290e",
  null
  
)

export default component.exports